import React from 'react';
import Dashboard from './Dashboard';
import RegistrarMulta from './RegistrarMulta';
import BuscarPagarMultas from './BuscarPagarMultas';
import Reportes from './Reportes';
import TiposInfraccion from './TiposInfraccion';
import UserManagement from './UserManagement';

// Este componente ahora recibe "isSuperAdmin" y "userRole" y se los pasa a los componentes que lo necesitan.
const MainContent = ({ page, userRole, currentUser, isSuperAdmin }) => {
    return (
        <main className="flex-1 p-4 sm:p-6 lg:p-10 bg-gray-100 overflow-y-auto">
            <div className="bg-white p-6 rounded-lg shadow-md min-h-full">
                {page === 'dashboard' && <Dashboard />}
                {page === 'registrar' && <RegistrarMulta />}
                {page === 'buscar' && <BuscarPagarMultas mode="buscar" userRole={userRole} isSuperAdmin={isSuperAdmin} />}
                {page === 'pagar' && <BuscarPagarMultas mode="pagar" userRole={userRole} isSuperAdmin={isSuperAdmin} />}
                {page === 'reportes' && <Reportes />}
                {page === 'infracciones' && <TiposInfraccion />}
                {page === 'usuarios' && <UserManagement currentUser={currentUser} />}
            </div>
        </main>
    );
};

export default MainContent;